
var url = window.location.href;
url = url.split('.html')[0];
//url = url.substring(0, url.lastIndexOf("."));
window.history.replaceState( null, null, url );

// FORM JS
// let contactBtn = document.querySelectorAll('.js-contact-btn');
let contactForm = document.querySelector(".js-contact-form-wrapper");
let overlay = document.querySelector(".contact-overlay");
let field = document.querySelector(".js-focus-field");
let mobileMenu = document.querySelector(".js-mobile-menu");
let hamburger = document.querySelector(".js-hamburger");
const mobileNavClose = document.querySelector(".js-mnav-btn");
const mobileNavLinks = document.querySelectorAll(".mobile-nav__link");


hamburger.addEventListener("click", ()=> {
// mobileMenu.classList.add("mobile-nav__container--active");
if (!mobileMenu.classList.contains('mobile-nav__container--active')) {
      mobileMenu.classList.add("mobile-nav__container--active");
      overlay.classList.add("overlay-active");
    } else {
      mobileMenu.classList.remove("mobile-nav__container--active");
      overlay.classList.remove("overlay-active");
    }
});

// mobile nav close
mobileNavClose.addEventListener("click", ()=>{
mobileMenu.classList.remove("mobile-nav__container--active");
      overlay.classList.remove("overlay-active");
});

mobileNavLinks.forEach(mobileNavLink =>{
  mobileNavLink.addEventListener("click", ()=> {
mobileMenu.classList.remove("mobile-nav__container--active");
      overlay.classList.remove("overlay-active");
  });
});

document.querySelectorAll(".js-contact-btn").forEach(item => {
  item.addEventListener("click", function () {

    field.focus();

    if (!contactForm.classList.contains('form-active')) {
      contactForm.classList.add("form-active");
      overlay.classList.add("overlay-active");
    } else {
      contactForm.classList.remove("form-active");
      overlay.classList.remove("overlay-active");
      inputElements.forEach((inputElement) => {
        inputElement.value = "";
        inputElement.closest(".contact-form__field").classList.remove("contact-form__field--valid");;
      });
      var $select = $(".chosen-select");
      $select
      .val([])                        // or .val(null) or .val("")
      .trigger("chosen:updated");     // forces UI refresh (placeholder appears, tags removed)

    }
  });
});

overlay.addEventListener("click", function () {
  contactForm.classList.remove("form-active");
  overlay.classList.remove("overlay-active");
  mobileMenu.classList.remove("mobile-nav__container--active")
  inputElements.forEach((inputElement) => {
        inputElement.value = "";
        inputElement.closest(".contact-form__field").classList.remove("contact-form__field--valid");;
      });
      var $select = $(".chosen-select");
      $select
      .val([])                        // or .val(null) or .val("")
      .trigger("chosen:updated");     // forces UI refresh (placeholder appears, tags removed)
});

document.getElementById('contact-form').addEventListener('submit', async function(event) {
  event.preventDefault();

  const form = event.target;
  const formData = new FormData(form);

  try {
    // Step 1: Execute reCAPTCHA v3 to get token (invisible, no user interaction)
    const token = await grecaptcha.execute('6Lf6VpQsAAAAAJsIFRfVwjpjJPm55Bjg2P-LKU1m', { action: 'submit' });
    
    // Step 2: Add the token to the form data (this is what Formspree expects)
    formData.append('g-recaptcha-response', token);

    // Debug: see what's being sent
    console.log('Form data with captcha:', Object.fromEntries(formData));
    console.log('job selections:', formData.getAll('job'));

    const response = await fetch('https://formspree.io/f/mbdzpenw', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData  // FormData handles multipart automatically
    });

    if (response.ok) {
      document.getElementById('success-message').style.display = 'block';
      document.getElementById('error-message').style.display = 'none';
      form.reset();
      inputElements.forEach((inputElement) => {
        inputElement.value = "";
        inputElement.closest(".contact-form__field").classList.remove("contact-form__field--valid");
      });
      document.querySelector('.chosen-select')?.dispatchEvent(new Event('chosen:updated'));
      setTimeout(() => document.getElementById('success-message').style.display = 'none', 5000);
    } else {
      const data = await response.json();
      console.error('Formspree error:', response.status, data);
      let errMsg = 'Submission failed.';
      if (data.errors) {
        errMsg = data.errors.map(e => e.message || e.field).join('; ');
      }
      document.getElementById('error-message').textContent = errMsg;
      document.getElementById('error-message').style.display = 'block';
    }
  } catch (err) {
    console.error('Error (captcha or network):', err);
    document.getElementById('error-message').textContent = 'Error – check console (likely captcha issue).';
    document.getElementById('error-message').style.display = 'block';
  }
});


(function () {

  var doc = document.documentElement;
  var w = window;

  var prevScroll = w.scrollY || doc.scrollTop;
  var curScroll;
  var direction = 0;
  var prevDirection = 0;

  var header = document.getElementById('site-header');

  var checkScroll = function () {

    /*
    ** Find the direction of scroll
    ** 0 - initial, 1 - up, 2 - down
    */

    curScroll = w.scrollY || doc.scrollTop;
    if (curScroll > prevScroll) {
      //scrolled up
      direction = 2;
    }
    else if (curScroll < prevScroll) {
      //scrolled down
      direction = 1;
    }

    // Update header background based on scroll position
    if (curScroll > document.querySelector(".hero").offsetHeight - 50) {
      header.classList.add("header--active");
    } else {
      header.classList.remove("header--active");
    }

    if (curScroll > document.querySelector(".hero").offsetHeight) {
      header.classList.remove('hide');
      prevDirection = direction;
    }
    else if (curScroll < 100) {
      header.classList.remove('hide');
      prevDirection = direction;
    }
    else {
      header.classList.add('hide');
      prevDirection = direction;
    }

    if (direction !== prevDirection) {
      toggleHeader(direction, curScroll);
    }

    prevScroll = curScroll;
  };

  var toggleHeader = function (direction, curScroll) {
    // if (direction === 2 && curScroll < document.querySelector(".hero").offsetHeight) {

    //   //replace 52 with the height of your header in px

    //   header.classList.add('hide');
    //   prevDirection = direction;
    // }
    // else if (direction === 1) {
    //   header.classList.remove('hide');
    //   prevDirection = direction;
    // } 
  };

  window.addEventListener('scroll', checkScroll);

})();

// Theme Toggle

document.querySelector('.js-theme-toggle').addEventListener('click', function () {
  document.querySelector('body').classList.toggle('dark-mode');
});

function setThemePreference() {
  var d = new Date();
  /*
  * The getHours() method returns the hour (from 0 to 23) of the specified date and time.
  * Early mornig = 0 - 6
  * Morning = 6 - 12
  * Evening = 12 - 18
  * Night = 18 - 23
  */
  var currentHour = d.getHours();

  if (currentHour >= 19 || currentHour <= 6) {
    document.body.setAttribute("class", "dark-mode")
  } else {
    document.body.setAttribute("class", "light_theme")
  }
}

document.addEventListener('DOMContentLoaded', function() {
    const textArray = ["developer?", "designer?", "creator?", "problem-solver?"];
    const element = document.getElementById("typewriter-text");
    let wordIndex = 0;
    let charIndex = 0;
    let isDeleting = false;

    function type() {
        const currentWord = textArray[wordIndex];
        
        if (isDeleting) {
            element.textContent = currentWord.substring(0, charIndex - 1);
            charIndex--;
        } else {
            element.textContent = currentWord.substring(0, charIndex + 1);
            charIndex++;
        }

        let typeSpeed = isDeleting ? 50 : 100; // Faster deleting, slower typing

        if (!isDeleting && charIndex === currentWord.length) {
            typeSpeed = 3000; // Pause at end of word
            isDeleting = true;
        } else if (isDeleting && charIndex === 0) {
            isDeleting = false;
            wordIndex = (wordIndex + 1) % textArray.length; // Move to next word
            typeSpeed = 500;
        }

        setTimeout(type, typeSpeed);
    }

    type();
});


// New Form Validation from yours truly



const inputElements = document.querySelectorAll(
  '.contact-form__field input[type="text"], .contact-form__field input[type="file"], .contact-form__field input[type="email"], .contact-form__field input[type="tel"], .contact-form__field select, .contact-form__field textarea'
);

inputElements.forEach((inputElement) => {
  inputElement.addEventListener("input", function () {
    const formFieldElement = inputElement.closest(".contact-form__field");
    const inputValue = inputElement.value.trim();
    const inputType = inputElement.type;
    const select = document.querySelector(".chosen-select");
    const selectField = document.querySelector(".chosen-select").closest(".contact-form__field");
    let isValid = false;

    if (inputType === "email") {
      isValid = isValidEmail(inputValue);
    } else if (inputType === "tel") {
      //Inputmask({mask: '(999) 999-9999'}).mask(inputElement)
      //$('.phone-us').mask('(000) 000-0000');
      isValid = isValidPhone(inputValue);
    } else if (inputValue.length > 0 && inputElement.localName == "textarea") {
      formFieldElement.classList.add("contact-form__field--textentered");
    } else if (
      inputValue.length === 0 &&
      inputElement.localName == "textarea"
    ) {
      formFieldElement.classList.remove("contact-form__field--textentered");
    } else {
      isValid = inputValue !== "";
    }

    if (isValid) {
      formFieldElement.classList.add("contact-form__field--valid");
    } else {
      formFieldElement.classList.remove("contact-form__field--valid");
    }

    // Function to toggle .valid class based on whether anything is selected
  


  // Listen for changes (Chosen triggers this on the original select)

  });

  inputElement.addEventListener("focus", function () {
    // console.log("focused");
    const formFieldElement = inputElement.closest(".contact-form__field");

    // // const formFieldLabel = formFieldElement.querySelector(".contact-form__label");

    // // formFieldLabel.classList.add("contact-form__label--focus");
  });

  inputElement.addEventListener("blur", function () {
    // console.log("blurred");
    const formFieldElement = inputElement.closest(".contact-form__field");

    // // const formFieldLabel = formFieldElement.querySelector(".contact-form__label");

    if (inputElement.value == "") {
      // // formFieldLabel.classList.remove("contact-form__label--focus");
    } else {
    }
  });
});

// Money Mask

const moneyInputs = document.querySelectorAll(".js-shift4");

if (moneyInputs) {
  moneyInputs.forEach((moneyInput) => {
    moneyInput.addEventListener('input', function (e) {
      let value = moneyInput.value.replace(/\D/g, ''); // Remove non-digits
      value = value.replace(/^0+/, ''); // Remove leading zeros

      if (value) {
        value = parseFloat(value / 100).toFixed(2); // Convert to decimal and format
        value = value.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'); // Add commas
        moneyInput.value = '$' + value; // Add currency symbol
      } else {
        moneyInput.value = '';
        moneyInput.closest(".contact-form__field").classList.remove("contact-form__field--valid");
      }
    });
  });
}

// End Money Mask

const zipInputs = document.querySelectorAll("input.zip");

zipInputs.forEach((zipInput) => {
  zipInput.addEventListener("input", function () {
    const zipFieldElement = zipInput.closest(".contact-form__field");

    let cleanedInput = this.value.replace(/\D/g, "");

    cleanedInput = cleanedInput.substring(0, 5);

    this.value = cleanedInput;

    if (/^\d{5}(-\d{4})?$/.test(cleanedInput)) {
      zipFieldElement.classList.add("contact-form__field--valid");
    } else {
      zipFieldElement.classList.remove("contact-form__field--valid");
    }
  });
});

function isValidEmail(email) {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^s@]+$/;
  return emailPattern.test(email);
}

const phoneInputs = document.querySelectorAll('input[type="tel"]');

phoneInputs.forEach((phoneInput) => {
  phoneInput.addEventListener("input", function () {
    const telFieldElement = phoneInput.closest(".contact-form__field");

    let cleanedInput = this.value.replace(/\D/g, "");

    cleanedInput = cleanedInput.substring(0, 10);

    this.value = cleanedInput;

    if (/^\d{10}(-\d{4})?$/.test(cleanedInput)) {
      telFieldElement.classList.add("contact-form__field--valid");
    } else {
      telFieldElement.classList.remove("contact-form__field--valid");
    }
    // phoneInput.setAttribute("pattern", "[0-9]{10}");
  });
});

// Multi Select validation shit for connect with an agent bleh
// Get the element, add a click listener...
if (document.querySelector(".js-input--coverage")) {
  window.addEventListener("keyup", function (e) {
    if (
      (e.target && e.target.nodeName == "LI" && e.key === "Enter") ||
      e.keyCode === 13
    ) {
      const multiSelectInputs = document.querySelectorAll(".chosen-choices");

      console.log("List item " + " was key pressed!");

      multiSelectInputs.forEach((multiSelectInput) => {
        if (multiSelectInput.getElementsByClassName("search-choice")[0]) {
          multiSelectInput
            .closest(".contact-form__field")
            .classList.add("contact-form__field--valid");
          multiSelectInput
            .closest(".contact-form__field")
            // .querySelector(".form__label")
            // .classList.add("form__label--multi-focus");
        } else {
          multiSelectInput
            .closest(".contact-form__field")
            .classList.remove("contact-form__field--valid");
          multiSelectInput
            .closest(".contact-form__field")
            // .querySelector(".form__label")
            // .classList.remove("form__label--multi-focus");
        }
      });
    }
  });

  window.addEventListener("mouseover", function (e) {
    const multiSelectInputs = document.querySelectorAll(".chosen-choices");
    // e.target is the clicked element!
    // If it was a list item
    if (e.target && e.target.nodeName == "LI") {
      console.log("List item " + " was hovered!");

      console.log(multiSelectInputs);

      multiSelectInputs.forEach((multiSelectInput) => {
        if (multiSelectInput.getElementsByClassName("search-choice")[0]) {
          multiSelectInput
            .closest(".contact-form__field")
            .classList.add("contact-form__field--valid");
          multiSelectInput
            .closest(".contact-form__field")
            // .querySelector(".form__label")
            // .classList.add("form__label--multi-focus");
        } else {
          multiSelectInput
            .closest(".contact-form__field")
            .classList.remove("contact-form__field--valid");
          multiSelectInput
            .closest(".contact-form__field")
            // .querySelector(".form__label")
            // .classList.remove("form__label--multi-focus");
        }
      });
    }

    if (e.target && e.target.nodeName == "UL") {
      console.log("UL " + " was hovered!");

      multiSelectInputs.forEach((multiSelectInput) => {
        if (multiSelectInput.getElementsByClassName("search-choice")[0]) {
          multiSelectInput
            .closest(".contact-form__field")
            .classList.add("contact-form__field--valid");
          multiSelectInput
            .closest(".contact-form__field")
            // .querySelector(".form__label")
            // .classList.add("form__label--multi-focus");
        } else {
          multiSelectInput
            .closest(".contact-form__field")
            .classList.remove("contact-form__field--valid");
          multiSelectInput
            .closest(".contact-form__field")
            // .querySelector(".form__label")
            // .classList.remove("form__label--multi-focus");
        }
      });
    }
  });
}


document.addEventListener('DOMContentLoaded', () => {
  // Fade in elements when scrolled to
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target); // Stop observing once faded in
    }
  });
}, { threshold: 0.1}); // Trigger when 10% of the element is visible

document.querySelectorAll('.fade-in-element').forEach(el => observer.observe(el));
});

document.addEventListener("DOMContentLoaded", (event) => {
      inputElements.forEach((inputElement) => {
        inputElement.value = "";
        inputElement.closest(".contact-form__field").classList.remove("contact-form__field--valid");
      });
});


// window.onload = setThemePreference;

// Sorting for future use

// const filters = document.querySelectorAll(".filter");
// const wrapper = document.querySelector(".js-video-row");
// const pagination = document.querySelector(".pagination");
// const items = document.querySelectorAll(".js-video-item");

// if (document.querySelector("#type")) {
//   document.querySelector("#type").addEventListener("input", (e) => {
//     e.preventDefault();
//     console.log(e.target);

//     const type = document.querySelector("select[name=type]").value;

//     const regionTitle = document.querySelector(".map__title h2");

//     // trigger a DOM reflow
//     void regionTitle.offsetWidth;

//     //do filtering
//     if (type) {
//       items.forEach((item) => {
//         if (item.classList.contains(type)) {
//           item.style.display = "block";
//         } else {
//           item.style.display = "none";
//         }
//       });
//       regionTitle.innerHTML =
//         type[0].toUpperCase() + type.slice(1).replace(/-/g, " ");
//     } else if (type === "") {
//       items.forEach((item) => {
//         item.style.display = "block";
//       });
//       regionTitle.innerHTML = "All Videos";
//     }
//   });
// }